import { CustomReportCategory } from '../../../../../../redux/context/customReports/typesCategory'
import { Company } from '../../../../../../types/company/Company'
import { Dimension } from '../../../../../../features/dimension/types/Dimension'
import { populateTreeFromData } from '../../category/Builder/treeImporter'
import { transformTitle } from '../../../../../../redux/context/customReports/transUtils'
import { State } from '../../category/Builder/types'
import { toLine } from '../../../../../../redux/context/customReports/utils'

export interface TransposedRowData {
  categoryId: string
  categoryName: string
  categoryPath: string
  company?: Company
  dimension?: Dimension
  leafCategory?: CustomReportCategory
  categoryStyle?: any
  [variableId: string]: any
}

export const buildTransposedRowData = (categories: CustomReportCategory[]): TransposedRowData[] => {
  if (!categories || categories.length === 0) return []

  const { nodesById, rootId } = populateTreeFromData(categories)
  const leafCategories: TransposedRowData[] = []

  interface ExtractLeavesContext {
    state: State
    company?: Company
    dimension?: Dimension
    isFunctionDecendant?: boolean
  }

  function extractLeaves(
    nodeId: string,
    path: string[] = [],
    context: ExtractLeavesContext = { state: State.Root }
  ): void {
    const node = nodesById[nodeId]
    if (!node) return

    const nodeName = toLine(transformTitle(node, categories, true)) ?? 'unnamed'
    const currentPath = node.type === 'root' ? path : [...path, nodeName]

    let nodeContext: ExtractLeavesContext = context
    switch (node.type) {
      case 'company':
        nodeContext = { ...context, company: node.company, state: State.Company }
        break
      case 'dimension':
        nodeContext = { ...context, dimension: node.dimension, state: State.Dimension }
        break
      case 'periodGroup':
        nodeContext = { ...context, state: State.PeriodGroup }
        break
      case 'function':
        nodeContext = { ...context, isFunctionDecendant: true }
        break
      default:
        nodeContext = context
    }

    if (node.type === 'function' || !node.childIds || node.childIds.length === 0) {
      if (node.type !== 'root') {
        const row: TransposedRowData = {
          categoryId: node.id,
          categoryName: nodeName,
          categoryPath: currentPath.join(' > '),
          company: nodeContext.company,
          dimension: nodeContext.dimension,
          style: node.style
        }
        row.leafCategory = node
        leafCategories.push(row)
      }
    } else {
      node.childIds.forEach(childId => extractLeaves(childId, currentPath, nodeContext))
    }
  }

  extractLeaves(rootId)
  return leafCategories
}
